export default __webpack_public_path__ + "static/media/3X4A0544_tn.fe42b4e9.jpg";